import { render, staticRenderFns } from "./ResourceForm.vue?vue&type=template&id=7d56b56d&scoped=true"
import script from "./ResourceForm.vue?vue&type=script&lang=js"
export * from "./ResourceForm.vue?vue&type=script&lang=js"
import style0 from "./ResourceForm.vue?vue&type=style&index=0&id=7d56b56d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56b56d",
  null
  
)

export default component.exports